<template>
  <div
      :style="{
        background: `rgba(0, 0, 0, 0.75) url(${image})`,
        backgroundBlendMode: `overlay`,
        backgroundSize: 'cover',
      }"
  >
    <div class="container d-flex fd-column:mo p-x-2:mo SECTION">
      <div class="HEADER-INFO">
        <h1>{{ content.title }}</h1>
        <p class="p-b-4 h5">{{ content.description }}</p>
        <a
            :href="this.$runtimeConstants.SALESFORCE_BECOME_A_PRO+href">
          <button class="BUTTON btn"> {{ content.cta }} </button>
        </a>
      </div>
      <div class="p-y-4"></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'pro-h2',

  computed: {
    ...mapGetters('homepage/contentful', ['proHomePage']),
    content () {
      return this.proHomePage.heroSection;
    },
    image () {
      return this.proHomePage.heroSection.image.fields.file.url;
    },
    href () {
      if (Object.keys(this.$route.query).length) {
        const params = this.$route.query.source
          ? `?source=${this.$route.query.source}`
          : '';
        const referrer = this.$route.query.referredById
          ? `&referredById=${this.$route.query.referredById}`
          : '';
        return params.concat(referrer);
      }
      return '';
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@homeservices/design-kit/tools";
.SECTION {
  margin-top: 117px;
  @include mobile-only(){
    margin-top: 59px;
  }
}
.HEADER-INFO {
  max-width: 60 * $unit;
  display: flex;
  flex-direction: column;
  justify-content: left;
  margin-right: 6 * $unit;
  color: white;
  p {
    max-width: 42 * $unit;
  }
}
.BUTTON {
  @include padding-x(4);
  @include padding-y(1);
  width: 161px;
  @include margin-bottom(10);
}
</style>
